import { h, Component } from "preact";
import loadScript from "load-script";
import Layout from "../../components/layout/Layout";

import config from "../../config";

class ZipMoney extends Component {
  constructor() {
    super();
    this.state = {
      loaded: typeof window !== "undefined" && window.zipMoney ? true : false
    };
  }

  componentDidMount() {
    const ZIP_WIDGET_SCRIPT = config("ZIP_WIDGET_SCRIPT");
    if (typeof window !== "undefined" && window.Zip) {
      this.setState({ loaded: true });
      return;
    }

    loadScript(ZIP_WIDGET_SCRIPT, (err, script) => {
      if (err) {
        return;
      }
      this.setState({ loaded: true });
      window.Zip.Widget.render();
    });
  }
  render() {
    const { loaded } = this.state;
    const merchant = config("ZIPMONET_MERCHANT_UNIQUE_ID");
    const env = config("ZIPMONEY_ENV");
    if (!loaded) {
      return null;
    }
    return (
      <div>
        <Layout transparent={true} background={true} border={false}>
          <div data-zm-merchant={merchant} data-env={env} />
          <div
            id="zip-LP"
            data-zm-asset="landingpage"
            data-zm-widget="inline"
          />
        </Layout>
      </div>
    );
  }
}
export default ZipMoney;
